import { View, ViewOpts } from '@play-co/timestep-core/ui';
import { Match2Reward } from 'src/replicant/match2/rewards/match2-rewards.ruleset';
import { Match2RewardItem } from '../components/Match2RewardItem';

export class Match2BundleSaleIcon extends View {
  public readonly icon: Match2RewardItem;

  constructor(opts: ViewOpts) {
    super({
      ...opts,
      width: 75,
      height: 70,
    });

    this.icon = new Match2RewardItem({
      superview: this,
      centerOnOrigin: true,
      x: this.style.width * 0.5,
      y: this.style.height * 0.5,
    });
  }

  public setup(reward: Match2Reward, scale: number) {
    this.icon.setReward(reward);
    this.icon.updateOpts({ scale });
  }
}
